<template>
  <div class="card">
    <div class="col-lg-12 list-header pad-header-bg clearfix">
      <div class="header-item-fix">
        <b-button variant="outline-secondary" @click="reset()" size="sm">
          <i class="bx bx-revision font-size-16 align-middle"></i>重置
        </b-button>
      </div>
      <div class="header-item-fix">
        <b-button variant="primary" @click="search()" size="sm">
          <i class="bx bx-search-alt-2 font-size-16 align-middle"></i>搜索
        </b-button>
      </div>
      <div class="header-item-fix">
        <b-form-input size="sm" type="text" placeholder="请输入搜索内容" v-model="listParam.contentKeyword" style="width:240px;"></b-form-input>
      </div>
      <div class="header-item-fix">
        <el-select v-model="listParam.verifyStatus" clearable placeholder="筛选状态" style="width:150px;" @change="chageStatus()">
          <el-option v-for="item in statusList" :key="item.value" :label="item.text" :value="item.value"></el-option>
        </el-select>
      </div>
    </div>
    <div class="card-body">
      <div class="col-lg-12">
        <div class="table-responsive">
          <table class="table project-list-table table-nowrap table-centered table-borderless align-middle table-hover">
            <thead>
              <tr>
                <th scope="col">ID</th>
                <th scope="col">优惠码</th>
                <th scope="col">手机号</th>
                <th scope="col">核销状态</th>
                <th scope="col">发放日期</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="list in listData" :key="list.id">
                <td>{{list.id}}</td>
                <td>{{list.couponCode}}</td>
                <td>{{list.phone}}</td>
                <td>
                  <!-- //核销状态 0未核销 1已核销 2已取消 -->
                  <template v-if="list.verifyStatus == 0">
                    未核销
                  </template>
                  <template v-if="list.verifyStatus == 1">
                    已核销
                  </template>
                  <template v-if="list.verifyStatus == 2">
                    已取消
                  </template>
                </td>
                <td>{{list.recevieTime}}</td>
              </tr>
              <tr v-if="!listData.length">
                <td colspan='5' style="text-align:center !important;">暂无数据</td>
              </tr>
            </tbody>
          </table>
        </div>
        <pagination :isBatch="false" ref="page" @pageCallback="pageCallback" v-show="listData.length"></pagination>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import Swal from "sweetalert2";
import pagination from "@/components/pagination/pagination.vue"; //置顶稿件
import question from "../../../server/api/question";

export default {
  components: {
    pagination,
  },
  mounted() {
    const id = this.$route.query.id;
    this.id = id;
    this.listParam.id = id;
    this.getDatas();
  },
  data() {
    return {
      id: 0,
      listData: [],
      statusList: [
        { text: "全部", value: "" },
        { text: "已核销", value: "1" },
        { text: "未核销", value: "0" },
        { text: "已作废", value: "2" },
      ],
      listParam: {
        contentKeyword: null,
        page: 1,
        pageSize: 20,
        id: 0,
        verifyStatus: null,
      },
    };
  },
  methods: {
    search() {
      this.getDatas();
    },
    chageStatus() {
      this.getDatas();
    },
    reset() {
      this.listParam = {
        contentKeyword: "",
        page: 1,
        pageSize: 20,
        id: this.id,
        verifyStatus: null,
      };
      this.search();
    },
    getDatas() {
      let params = this.utils.getQuery(this.listParam);
      console.log(params);
      question.discoupon(params).then((resp) => {
        console.log(resp);
        if (resp.data) {
          if (resp.data.items) {
            let ids = [];
            resp.data.items.map((item) => {
              ids.push(item.id);
            });
            this.choiceListIds = [];
            this.allListIds = ids; //当前列表全部id
            this.listData = resp.data.items;
            let pages = {
              page: resp.data.page, //第几页
              pageSize: resp.data.pageSize, //每页多少条
              total: resp.data.total, //全部有多少条数据
              totalPages: resp.data.totalPages, //全部有几页
            };
            this.$nextTick(() => {
  if (this.$refs.page) {
    this.$refs.page.setPages(pages);
  }
});
          }
        }
      });
    },
    //给组件的回调
    pageCallback(obj) {
      if (obj.code === "page") {
        //更改页码
        this.pageParams.page = obj.page;
        this.getDatas();
      }
    },
  },
};
</script>

